import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { DEPARTMENTS } from "@/lib/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export default function Departments() {
  return (
    <section id="bolumler" data-testid="departments-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="text-sm uppercase tracking-[0.2em] text-[#1B19A8] font-semibold">02 · Popüler Bölümler</span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1a1a1a] mt-4 leading-tight">
              Hangi bölümü <span className="text-[#1B19A8]">seçeceksin?</span>
            </h2>
          </div>
          <a href="#basvuru" className="inline-flex items-center gap-2 text-[#1B19A8] font-semibold hover:gap-3 transition-[gap]">
            Tümü için başvur <ArrowUpRight size={18} />
          </a>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5"
        >
          {DEPARTMENTS.map((d, i) => (
            <motion.div
              key={d.name}
              variants={fadeUp}
              custom={i}
              whileHover={{ y: -6 }}
              data-testid={`department-card-${i}`}
              className={`group relative rounded-3xl p-7 border transition-colors ${
                d.featured
                  ? "bg-[#1B19A8] border-[#1B19A8] text-white shadow-[0_16px_40px_rgba(31,78,95,0.25)]"
                  : "bg-[#f7f9fa] border-black/5 text-[#1a1a1a] hover:border-[#1B19A8]/30"
              }`}
            >
              {d.featured && (
                <span className="absolute top-5 right-5 text-[10px] uppercase tracking-widest font-bold text-[#1a1a1a] bg-[#FFE500] px-2.5 py-1 rounded-full">
                  Popüler
                </span>
              )}
              <span className={`grid place-items-center w-12 h-12 rounded-2xl mb-6 ${d.featured ? "bg-white/15 text-white" : "bg-[#1B19A8]/8 text-[#1B19A8]"}`}>
                <d.icon size={24} strokeWidth={2} />
              </span>
              <h3 className="font-display text-xl font-bold mb-2">{d.name}</h3>
              <p className={`text-sm leading-relaxed ${d.featured ? "text-white/75" : "text-[#1a1a1a]/60"}`}>
                {d.note}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
